<div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-4 space-y-4">
  <!-- Sticky top: header + (on small) collapsible filter/sort toolbar stay pinned while the list scrolls. -->
  <div class="sticky top-0 z-20 -mx-4 sm:-mx-6 lg:-mx-8 -mt-4 px-4 sm:px-6 lg:px-8 pt-4 pb-3 space-y-3">
  <!-- Header: title + primary "new company" action; reflows to a column on phones. -->
  <div class="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
    <div class="flex items-center gap-3">
      <span class="inline-flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-theme-primary-50 text-theme-primary-600">
        <svg class="h-6 w-6" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
          <path d="M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6.5a.5.5 0 0 1-1 0V1H3v14h3v-2.5a.5.5 0 0 1 .5-.5H8v4H3a1 1 0 0 1-1-1V1Z"/>
          <path d="M4.5 2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm-6 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm-6 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z"/>
        </svg>
      </span>
      <div>
        <h1 class="text-xl font-bold text-gray-900 tracking-tight">Unternehmen</h1>
        <p class="text-sm text-gray-500">Verwalte alle Unternehmen der Plattform.</p>
      </div>
    </div>
    <div class="flex items-center justify-center gap-2 lg:justify-end">
      <button type="button" (click)="showFilters = !showFilters"
              class="inline-flex lg:hidden items-center gap-2 rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-600 shadow-sm hover:bg-gray-50 hover:border-gray-300 transition-all duration-200">
        <svg class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path d="M2.628 1.601C5.028 1.206 7.49 1 10 1s4.973.206 7.372.601a.75.75 0 0 1 .628.74v2.288a2.25 2.25 0 0 1-.659 1.59l-4.682 4.683a2.25 2.25 0 0 0-.659 1.59v3.037c0 .684-.31 1.33-.844 1.757l-1.937 1.55A.75.75 0 0 1 7.5 18.25v-5.757a2.25 2.25 0 0 0-.659-1.591L2.16 6.22A2.25 2.25 0 0 1 1.5 4.629V2.34a.75.75 0 0 1 .628-.74Z"/>
        </svg>
        Filter
        <svg class="h-4 w-4 transition-transform duration-200" [class.rotate-180]="showFilters"
             viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd"/>
        </svg>
      </button>
      <button (click)="redirectToSettings('')" type="button"
              class="inline-flex items-center justify-center px-4 py-2 text-sm bg-theme-primary-600 text-white rounded-xl
                     hover:bg-theme-primary-700 font-semibold shadow-lg shadow-theme-primary-100 hover:shadow-xl
                     transition-all duration-200 active:scale-95">
        <svg class="h-4 w-4 mr-1.5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path d="M10 5a.75.75 0 0 1 .75.75v3.5h3.5a.75.75 0 0 1 0 1.5h-3.5v3.5a.75.75 0 0 1-1.5 0v-3.5h-3.5a.75.75 0 0 1 0-1.5h3.5v-3.5A.75.75 0 0 1 10 5Z"/>
        </svg>
        Neues Unternehmen
      </button>
    </div>
  </div>

  <!-- Toolbar: search + status filter + sort. Collapsible on small (toggled by Filter), always shown on lg. -->
  <div [ngClass]="showFilters ? 'flex' : 'hidden'"
       class="flex-col gap-3 lg:flex-row lg:items-center lg:!flex">
    <div class="relative flex-1">
      <svg class="pointer-events-none absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400"
           viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path fill-rule="evenodd"
              d="M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z"
              clip-rule="evenodd"/>
      </svg>
      <input #searchInput (input)="FilterItem(searchInput.value)" type="text" placeholder="Unternehmen suchen…"
             class="block w-full rounded-xl border border-gray-200 bg-white py-2.5 pl-10 pr-3 shadow-sm
                    focus:border-theme-primary-500 focus:ring-1 focus:ring-theme-primary-500 sm:text-sm
                    transition-all duration-200 placeholder-gray-300">
    </div>
    <div class="flex w-full lg:w-auto rounded-xl border border-gray-200 bg-white p-1 shadow-sm">
      <button type="button" (click)="setActiveFilter('all')"
              class="flex-1 lg:flex-none whitespace-nowrap px-3 py-1.5 text-sm font-medium rounded-lg transition-all duration-200"
              [ngClass]="activeFilter === 'all' ? 'bg-theme-primary-50 text-theme-primary-600 shadow-sm' : 'text-gray-500 hover:bg-gray-100/80 hover:text-gray-900'">Alle</button>
      <button type="button" (click)="setActiveFilter('active')"
              class="flex-1 lg:flex-none whitespace-nowrap px-3 py-1.5 text-sm font-medium rounded-lg transition-all duration-200"
              [ngClass]="activeFilter === 'active' ? 'bg-theme-primary-50 text-theme-primary-600 shadow-sm' : 'text-gray-500 hover:bg-gray-100/80 hover:text-gray-900'">Aktiv</button>
      <button type="button" (click)="setActiveFilter('inactive')"
              class="flex-1 lg:flex-none whitespace-nowrap px-3 py-1.5 text-sm font-medium rounded-lg transition-all duration-200"
              [ngClass]="activeFilter === 'inactive' ? 'bg-theme-primary-50 text-theme-primary-600 shadow-sm' : 'text-gray-500 hover:bg-gray-100/80 hover:text-gray-900'">Inaktiv</button>
    </div>
    <select (change)="setSort($any($event.target).value)"
            class="w-full lg:w-auto rounded-xl border border-gray-200 bg-white py-2.5 pl-3 pr-8 text-sm text-gray-700 shadow-sm
                   focus:border-theme-primary-500 focus:ring-1 focus:ring-theme-primary-500 transition-all duration-200">
      <option value="name" [selected]="sortKey === 'name'">Name (A–Z)</option>
      <option value="newest" [selected]="sortKey === 'newest'">Neueste</option>
      <option value="modified" [selected]="sortKey === 'modified'">Zuletzt geändert</option>
    </select>
  </div>
  </div>
  @if (companies != undefined) {
    <p class="text-sm text-gray-500">
      <span class="font-semibold text-gray-700">{{ filtered_companies?.length || 0 }}</span>
      von {{ companies.length }} Unternehmen
    </p>
  }

  @if (companies == undefined) {
    <app-loading></app-loading>
  }

  @if (companies != undefined && filtered_companies?.length === 0) {
    <p class="text-sm text-gray-500 italic py-6 border-2 border-dashed border-gray-100 rounded-2xl text-center">
      {{ searchText || activeFilter !== 'all' ? 'Keine Unternehmen gefunden.' : 'Noch keine Unternehmen angelegt.' }}
    </p>
  }

  @if (filtered_companies && filtered_companies.length > 0) {
    <!-- Desktop: data table. -->
    <div class="hidden md:block overflow-x-auto rounded-2xl border border-gray-100 bg-white shadow-sm">
      <table class="min-w-full divide-y divide-gray-100 text-sm">
        <thead class="bg-gray-50">
          <tr class="text-left text-xs uppercase tracking-wide text-gray-500">
            <th class="px-4 py-3 font-semibold">Unternehmen</th>
            <th class="px-4 py-3 font-semibold">Adresse</th>
            <th class="px-4 py-3 font-semibold">Status</th>
            <th class="px-4 py-3 text-right font-semibold">Aktionen</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100">
          @for (company of filtered_companies; track company.id) {
          <tr class="transition-colors hover:bg-gray-50">
            <td class="px-4 py-3">
              <div class="flex items-center gap-3">
                <img alt="" class="h-9 w-9 flex-shrink-0 rounded-xl" src="./assets/images/icon_nobackground_md.png">
                <a [routerLink]="['/owner/shards']" [queryParams]="{ company: company.id }" queryParamsHandling="merge"
                   class="group min-w-0">
                  <span class="block truncate font-semibold text-gray-900 transition-colors group-hover:text-theme-primary-700">{{ company.name }}</span>
                  <span class="block truncate font-mono text-xs text-gray-500">{{ company.id }}</span>
                </a>
              </div>
            </td>
            <td class="px-4 py-3 text-gray-600">
              @if (company.address) {
                {{ company.address.street }} {{ company.address.houseNumber }}, {{ company.address.zip }} {{ company.address.city }}
              } @else {
                <span class="text-xs font-semibold text-red-500">— fehlt</span>
              }
            </td>
            <td class="px-4 py-3">
              <span class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold"
                    [ngClass]="company.active ? 'bg-green-50 text-green-700' : 'bg-gray-100 text-gray-600'">{{ company.active ? 'Aktiv' : 'Inaktiv' }}</span>
            </td>
            <td class="px-4 py-3">
              <div class="flex items-center justify-end gap-1">
                <button (click)="contractsCompany = company" type="button" aria-label="Verträge verwalten" title="Verträge verwalten"
                        class="inline-flex h-8 w-8 items-center justify-center rounded-lg text-gray-400 hover:bg-gray-100 hover:text-gray-700 transition-all duration-200 active:scale-95">
                  <svg class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path d="M4.5 2A1.5 1.5 0 0 0 3 3.5v13A1.5 1.5 0 0 0 4.5 18h11a1.5 1.5 0 0 0 1.5-1.5V7.621a1.5 1.5 0 0 0-.44-1.06l-3.62-3.622A1.5 1.5 0 0 0 11.379 2H4.5ZM6.75 7a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Zm0 3a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Zm0 3a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5h-3.5Z"/>
                  </svg>
                </button>
                <button (click)="redirectToSettings(company.id)" type="button" aria-label="Bearbeiten"
                        class="inline-flex h-8 w-8 items-center justify-center rounded-lg text-gray-400 hover:bg-gray-100 hover:text-gray-700 transition-all duration-200 active:scale-95">
                  <svg class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path d="M2.695 14.762l-1.262 3.155a.5.5 0 0 0 .65.65l3.155-1.262a4 4 0 0 0 1.343-.886L17.5 5.501a2.121 2.121 0 0 0-3-3L3.58 13.419a4 4 0 0 0-.885 1.343Z"/>
                  </svg>
                </button>
                <button (click)="RemoveCompany(company)" type="button" aria-label="Löschen"
                        class="inline-flex h-8 w-8 items-center justify-center rounded-lg text-gray-400 hover:bg-red-50 hover:text-red-600 transition-all duration-200 active:scale-95">
                  <svg class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd"
                          d="M8.75 1A2.75 2.75 0 0 0 6 3.75v.443c-.795.077-1.583.176-2.365.298a.75.75 0 1 0 .23 1.482l.149-.022.841 10.518A2.75 2.75 0 0 0 7.596 19h4.807a2.75 2.75 0 0 0 2.742-2.53l.841-10.52.149.023a.75.75 0 0 0 .23-1.482A41.03 41.03 0 0 0 14 4.193V3.75A2.75 2.75 0 0 0 11.25 1h-2.5ZM10 4c.84 0 1.673.025 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325C8.327 4.025 9.16 4 10 4ZM8.58 7.72a.75.75 0 0 0-1.5.06l.3 7.5a.75.75 0 1 0 1.5-.06l-.3-7.5Zm4.34.06a.75.75 0 1 0-1.5-.06l-.3 7.5a.75.75 0 1 0 1.5.06l.3-7.5Z"
                          clip-rule="evenodd"/>
                  </svg>
                </button>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- Mobile: cards. -->
    <ul class="grid grid-cols-1 gap-4 md:hidden" role="list">
      @for (company of filtered_companies; track company.id) {
      <li class="flex flex-col border border-gray-100 rounded-2xl p-4 bg-white shadow-sm hover:shadow-md transition-all">
        <div class="flex items-start gap-3">
          <img alt="" class="h-12 w-12 flex-shrink-0 rounded-2xl" src="./assets/images/icon_nobackground_md.png">
          <a [routerLink]="['/owner/shards']" [queryParams]="{ company: company.id }" queryParamsHandling="merge"
             class="group min-w-0 flex-1 cursor-pointer">
            <span class="block truncate text-sm font-bold text-gray-900 transition-colors group-hover:text-theme-primary-700">{{ company.name }}</span>
            <span class="block truncate font-mono text-xs text-gray-500">{{ company.id }}</span>
          </a>
          <div class="flex flex-shrink-0 items-center gap-1">
            <button (click)="contractsCompany = company" type="button" aria-label="Verträge verwalten" title="Verträge verwalten"
                    class="inline-flex h-9 w-9 items-center justify-center rounded-xl text-gray-400 hover:bg-gray-100 hover:text-gray-700 transition-all duration-200 active:scale-95">
              <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path d="M4.5 2A1.5 1.5 0 0 0 3 3.5v13A1.5 1.5 0 0 0 4.5 18h11a1.5 1.5 0 0 0 1.5-1.5V7.621a1.5 1.5 0 0 0-.44-1.06l-3.62-3.622A1.5 1.5 0 0 0 11.379 2H4.5ZM6.75 7a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Zm0 3a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Zm0 3a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5h-3.5Z"/>
              </svg>
            </button>
            <button (click)="redirectToSettings(company.id)" type="button" aria-label="Bearbeiten"
                    class="inline-flex h-9 w-9 items-center justify-center rounded-xl text-gray-400 hover:bg-gray-100 hover:text-gray-700 transition-all duration-200 active:scale-95">
              <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path d="M2.695 14.762l-1.262 3.155a.5.5 0 0 0 .65.65l3.155-1.262a4 4 0 0 0 1.343-.886L17.5 5.501a2.121 2.121 0 0 0-3-3L3.58 13.419a4 4 0 0 0-.885 1.343Z"/>
              </svg>
            </button>
            <button (click)="RemoveCompany(company)" type="button" aria-label="Löschen"
                    class="inline-flex h-9 w-9 items-center justify-center rounded-xl text-gray-400 hover:bg-red-50 hover:text-red-600 transition-all duration-200 active:scale-95">
              <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd"
                      d="M8.75 1A2.75 2.75 0 0 0 6 3.75v.443c-.795.077-1.583.176-2.365.298a.75.75 0 1 0 .23 1.482l.149-.022.841 10.518A2.75 2.75 0 0 0 7.596 19h4.807a2.75 2.75 0 0 0 2.742-2.53l.841-10.52.149.023a.75.75 0 0 0 .23-1.482A41.03 41.03 0 0 0 14 4.193V3.75A2.75 2.75 0 0 0 11.25 1h-2.5ZM10 4c.84 0 1.673.025 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325C8.327 4.025 9.16 4 10 4ZM8.58 7.72a.75.75 0 0 0-1.5.06l.3 7.5a.75.75 0 1 0 1.5-.06l-.3-7.5Zm4.34.06a.75.75 0 1 0-1.5-.06l-.3 7.5a.75.75 0 1 0 1.5.06l.3-7.5Z"
                      clip-rule="evenodd"/>
              </svg>
            </button>
          </div>
        </div>

        <hr class="my-3 border-gray-100">

        @if (company.address) {
          <div class="flex gap-2 text-sm">
            <span class="font-bold text-gray-700">Adresse</span>
            <div class="text-gray-500">
              <span class="block">{{ company.address.street }} {{ company.address.houseNumber }}</span>
              @if (company.address.additionalAddressLine) {
                <span class="block">{{ company.address.additionalAddressLine }}</span>
              }
              <span class="block">{{ company.address.zip }} {{ company.address.city }}</span>
            </div>
          </div>
        } @else {
          <span class="inline-flex items-center gap-1 text-xs font-semibold text-red-500">
            <svg class="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd"
                    d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
                    clip-rule="evenodd"/>
            </svg>
            Adresse fehlt
          </span>
        }

        <hr class="my-3 border-gray-100">

        <div class="mt-auto flex flex-wrap items-center gap-2 text-sm">
          <span class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold"
                [ngClass]="company.active ? 'bg-green-50 text-green-700' : 'bg-gray-100 text-gray-600'">{{ company.active ? 'Aktiv' : 'Inaktiv' }}</span>
        </div>
      </li>
      }
    </ul>
  }
</div>

<!-- Contract management modal (opened from a row's "Verträge" action). -->
@if (contractsCompany) {
  <app-company-contracts [company]="contractsCompany" (closed)="contractsCompany = undefined"></app-company-contracts>
}
